import { render, staticRenderFns } from "./SummaryTopVideos.vue?vue&type=template&id=1c32bc0a&scoped=true&"
import script from "./SummaryTopVideos.vue?vue&type=script&lang=js&"
export * from "./SummaryTopVideos.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTopVideos.vue?vue&type=style&index=0&id=1c32bc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32bc0a",
  null
  
)

export default component.exports